// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2OxP0","approved":"Status_approved__3vmwR","rejected":"Status_rejected__1xhSF","expired":"Status_expired__283wZ","label":"Status_label__1Ty5q"};